import styled from 'styled-components/macro';
import { Avatar as AntdAvatar } from 'antd';

export const Avatar = styled(AntdAvatar)``;
